import React from 'react';
import PropTypes from 'prop-types';
import api from '../../../Api';
import makeConnectTo from '../../util/makeConnectTo';
import { notification } from 'antd';
import { connectToCollectionTitles } from './CollectionTitlesDataStore';

const CatalogContext = React.createContext();

const name = 'catalogStore';

export const connectToCatalog = makeConnectTo(CatalogContext, name);

export class CatalogDataStore extends React.Component {
	static propTypes = {
		catalogId: PropTypes.string.isRequired,
		children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
	};

	state = {
		isLoading: true,
		catalogData: null,
	};

	render() {
		const catalogStore = this.getStore();
		return (
			<CatalogContext.Provider value={catalogStore}>
				{typeof this.props.children === 'function'
					? this.props.children(catalogStore)
					: this.props.children}
			</CatalogContext.Provider>
		);
	}

	componentDidMount() {
		this.fetchCatalog();
	}

	componentWillUnmount() {
		if (
			this.catalogFetch &&
			typeof this.catalogFetch.cancel === 'function'
		) {
			this.catalogFetch.cancel();
		}
	}

	getStore = (state = this.state) => ({
		state,
		isLoading: () => state.isLoading,
		getCatalog: () => (state.catalogData ? state.catalogData.catalog : {}),
		refresh: () => this.refreshCatalog(),
		editExistingCollection: (fieldName, values) =>
			this.editExistingCollection(fieldName, values),
		deleteCollection: () => this.deleteCollection(),
		resequenceCollection: skus => this.resequenceCollection(skus),
		removeTitlesFromCollection: skus =>
			this.removeTitlesFromCollection(skus),
		addTitlesToCollection: skus => this.addTitlesToCollection(skus),
	});

	refreshCatalog = () => {
		return this.fetchCatalog();
	};

	fetchCatalog = () => {
		const { catalogId } = this.props;
		const request = api.cancelableGet(`/api/v1/catalogs/${catalogId}`);
		request.promise.then(this.cacheApiResponse);
		this.catalogFetch = request;
		return this.catalogFetch.promise;
	};

	cacheApiResponse = apiResponse => {
		this.setState({ isLoading: false, catalogData: apiResponse });
	};

	editExistingCollection = (fieldName, value) => {
		return api
			.put(
				`/api/v1/catalogs/${this.props.catalogId}/${fieldName}`,
				encodeURIComponent(value),
			)
			.then(() => {
				return this.refreshCatalog();
			});
	};

	deleteCollection() {
		const endpoint = `/api/v1/catalogs/${this.props.catalogId}`;
		return api.call('DELETE', endpoint).then(() => {
			notification.success({
				message: `Successfully deleted this collection`,
			});
			return this.refreshCatalog();
		});
	}

	resequenceCollection = skus => {
		const endpoint = `/api/v1/catalogs/${this.props.catalogId}/titles/resequence`;
		return api.call('PUT', endpoint, skus).then(() => {
			this.props.collectionTitlesDataStore.refresh();
			return this.refreshCatalog();
		});
	};

	removeTitlesFromCollection = skus => {
		const endpoint = `/api/v1/catalogs/${this.props.catalogId}/titles`;
		return api.call('DELETE', endpoint, skus).then(() => {
			this.props.collectionTitlesDataStore && this.props.collectionTitlesDataStore.refresh();
			return this.refreshCatalog();
		});
	};

	addTitlesToCollection = skus => {
		const endpoint = `/api/v1/catalogs/${this.props.catalogId}/titles`;
		return api.call('PUT', endpoint, skus).then(() => {
			this.props.collectionTitlesDataStore && this.props.collectionTitlesDataStore.refresh();
			return this.refreshCatalog();
		});
	};
}

export default connectToCollectionTitles(CatalogDataStore);
